import { FormType } from "./post.service";

interface ContactConfig {
  name: string;
  linkedIn: string;
  imgUrl: string;
  altDescription: string;
  position: string;
  mailTo: string;
  titleSlogan: string;
  slogan?: string;
  successMessage: string;
  errorMessage: string;
  formType: FormType;
}

export const HR_CONFIG: ContactConfig = {
  name: "Kornelia Podsiadło",
  linkedIn: "https://www.linkedin.com/in/korneliapodsiadlo/",
  imgUrl: "kornelia-hr",
  altDescription: "Kornelia Podsiadło HR lead",
  position: "HR lead",
  mailTo: "hr@niceproject.eu",
  titleSlogan: "APPLY FOR THE JOB",
  successMessage:
    "You have successfully sent the application request. Good luck!",
  errorMessage: "Something went wrong. Please try again.",
  formType: "job-application" as FormType,
};

export const CEO_CONFIG: ContactConfig = {
  name: "Mariusz Lewandowski",
  linkedIn: "https://www.linkedin.com/in/mariusz-lewandowski-05a14911a/",
  imgUrl: "ceo",
  altDescription: "Mariusz Lewandowski CEO",
  position: "CEO",
  mailTo: "hello@niceproject.eu",
  titleSlogan: "HAVE A NICE PROJECT IN MIND?",
  slogan:
    "Do you want to start a nice project with us or join our team? Talk to us!",
  successMessage: "You have successfully sent your message.",
  errorMessage: "Something went wrong. Please try again.",
  formType: "contact" as FormType,
};
